import React, { useEffect, useRef } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { IoCaretBackCircle } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { selectVideoById } from "../redux/ApiSlice/WatchVideoSlice";

const ViewPostById = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const videoRef = useRef(null);

    const { videoData, loading } = useSelector((state) => state.WatchVideo);

    useEffect(() => {
        dispatch(selectVideoById(id));
    }, [id]);

    const handleVideoClick = () => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        }
    };

    return (
        <div className="relative w-full h-full bg-black overflow-hidden">
            <IoCaretBackCircle
                onClick={() => navigate(-1)}
                className="absolute top-2 left-2 text-xl text-white cursor-pointer hover:transform hover:scale-110 transition-transform duration-500"
            />
            {loading ? (
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <ClipLoader size={40} color={"#000000"} />
                </div>
            ) : (
                <div className="h-full">
                    <video
                        loop
                        autoPlay
                        ref={videoRef}
                        disableRemotePlayback
                        disablePictureInPicture
                        src={videoData?.video_url}
                        onClick={handleVideoClick}
                        className="w-full h-full object-cover"
                    />

                    <div className="absolute w-full bottom-[1rem]">
                        <div className={`flex items-end justify-between px-2`}>
                            <div className="w-[80%]">
                                <p
                                    onClick={() => navigate(`/account/${videoData.created_by?.id}`)}
                                    className="text-white font-bold text-[14px] cursor-pointer"
                                >
                                    {videoData.created_by?.first_name} {videoData.created_by?.last_name}
                                </p>
                                <div className="w-[90%]">
                                    <p className="text-[12px] text-white pt-1 line-clamp-1">
                                        {videoData.post_description}
                                    </p>
                                </div>
                            </div>

                            <div className="flex flex-col relative items-center">
                                <img
                                    alt={videoData.created_by?.first_name}
                                    src={videoData.created_by?.avatar_url}
                                    onClick={() => navigate(`/account/${videoData.created_by?.id}`)}
                                    className="object-cover w-10 h-10 rounded-md bg-gray-500"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ViewPostById;